import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { USER } from "./actionTypes";

const INIT_STATE = {
  listaUser: {
    totalRecords: 0,
    records: [],
  },
  loadingUser: true,
  filterUser: null,
  dropdownUser: [],
  user: null,
  messageUser: null,
  isUserSave: null,
  pageSizeUser: DEFAULT_PAGE_SIZE,
  errorLoadingUser: null,
};

const UserReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case USER.GET_LISTA_USER.REQUEST:
      return {
        ...state,
        filterUser: action.payload,
        loadingUser: true,
      };

    case USER.GET_LISTA_USER.SUCCESS:
      return {
        ...state,
        listaUser: action.payload,
        loadingUser: false,
      };

    case USER.GET_LISTA_USER.FAIL:
      return {
        ...state,
        messageUser: action.payload,
        loadingUser: false,
      };
    case USER.GET_DROPDOWN_USER.REQUEST:
      return {
        ...state,
      };

    case USER.GET_DROPDOWN_USER.SUCCESS:
      return {
        ...state,
        dropdownUser: action.payload,
      };

    case USER.GET_DROPDOWN_USER.FAIL:
      return {
        ...state,
        dropdownUser: action.payload,
      };
    case USER.GET_USER.REQUEST:
      return {
        ...state,
        loadingUser: true,
      };

    case USER.GET_USER.SUCCESS:
      return {
        ...state,
        user: action.payload,
        loadingUser: false,
      };

    case USER.GET_USER.FAIL:
      return {
        ...state,
        messageUser: action.payload,
        loadingUser: false,
        errorLoadingUser: true,
      };
    case USER.SAVE_USER.REQUEST:
      return {
        loadingUser: true,
        ...state,
      };

    case USER.SAVE_USER.SUCCESS:
      return {
        ...state,
        loadingUser: false,
        isUserSave: action.payload,
      };

    case USER.SAVE_USER.FAIL:
      return {
        ...state,
        loadingUser: false,
        messageUser: action.payload,
        isUserSave: false
      };

    case USER.LOAD_EMPTY_USER:
      return {
        ...state,
        loadingUser: false,
        user: null,
        errorLoadingUser: null,
      };

    case USER.CLEAN_MESSAGE_USER:
      return {
        ...state,
        messageUser: null,
        isUserSave: null,
        loadingUser: false,
      };

    case USER.CHANGE_PAGE_SIZE_USER:
      return {
        ...state,
        pageSizeUser: action.payload,
      };

    default:
      return state;
  }
};

export default UserReducer;
